import type React from "react";
import { cn } from "src/shadcn/lib/utils";

import {
  ToggleGroup as ShadcnToggleGroup,
  ToggleGroupItem as ShadcnToggleGroupItem,
} from "src/shadcn/components/toggle-group";

const ToggleGroup = (props: React.ComponentProps<typeof ShadcnToggleGroup>) => (
  <ShadcnToggleGroup {...props} />
);

const ToggleGroupItem = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnToggleGroupItem>) => (
  <ShadcnToggleGroupItem
    className={cn("cursor-pointer disabled:cursor-not-allowed", className)}
    {...props}
  />
);

export { ToggleGroup, ToggleGroupItem };
